var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { ClassLinkItem } from './ClassLinkItem';
import { CleverItem } from './CleverItem';
import { FerpaItem } from './FerpaItem';
import { ClassLinkFerpa } from './ClassLinkFerpa';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-3dpowq" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 160px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  ", " {\n    width: 710px;\n    height: 136px;\n  }\n  ", " {\n    align-items: unset;\n    height: 190px;\n    width: 316px;\n  }\n"], ["\n  height: 160px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  ", " {\n    width: 710px;\n    height: 136px;\n  }\n  ", " {\n    align-items: unset;\n    height: 190px;\n    width: 316px;\n  }\n"])), function (_a) {
    var down = _a.theme.down;
    return down('tablet');
}, function (_a) {
    var down = _a.theme.down;
    return down('phone');
});
var InnerContainer = styled.div.withConfig({ displayName: "InnerContainer", componentId: "sc-14trdam" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n\n  & > :not(:last-child) {\n    margin-right: 87px;\n  }\n\n  ", " {\n    align-items: center;\n    & > :not(:last-child) {\n      margin-right: 0;\n    }\n  }\n\n  ", " {\n    flex-flow: column;\n    justify-content: center;\n    align-items: flex-start;\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n\n  & > :not(:last-child) {\n    margin-right: 87px;\n  }\n\n  ", " {\n    align-items: center;\n    & > :not(:last-child) {\n      margin-right: 0;\n    }\n  }\n\n  ", " {\n    flex-flow: column;\n    justify-content: center;\n    align-items: flex-start;\n  }\n"])), function (_a) {
    var down = _a.theme.down;
    return down('tablet');
}, function (_a) {
    var down = _a.theme.down;
    return down('phone');
});
var ScClassLinkItem = styled(ClassLinkItem).withConfig({ displayName: "ScClassLinkItem", componentId: "sc-u3gttu" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", " {\n    display: none;\n  }\n"], ["\n  ", " {\n    display: none;\n  }\n"])), function (_a) {
    var down = _a.theme.down;
    return down('tablet');
});
var ScFerpaItem = styled(FerpaItem).withConfig({ displayName: "ScFerpaItem", componentId: "sc-17pljij" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", " {\n    display: none;\n  }\n"], ["\n  ", " {\n    display: none;\n  }\n"])), function (_a) {
    var down = _a.theme.down;
    return down('tablet');
});
var ScClassLinkFerpa = styled(ClassLinkFerpa).withConfig({ displayName: "ScClassLinkFerpa", componentId: "sc-1nf6pev" })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: none;\n  ", " {\n    display: flex;\n  }\n"], ["\n  display: none;\n  ", " {\n    display: flex;\n  }\n"])), function (_a) {
    var down = _a.theme.down;
    return down('tablet');
});
var ScCleverItem = styled(CleverItem).withConfig({ displayName: "ScCleverItem", componentId: "sc-3r1s3h" })(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", " {\n    margin-bottom: 36px;\n  }\n"], ["\n  ", " {\n    margin-bottom: 36px;\n  }\n"])), function (_a) {
    var down = _a.theme.down;
    return down('phone');
});
var SocialList = function (_a) {
    var rest = __rest(_a, []);
    return (_jsx(Container, __assign({}, rest, { children: _jsxs(InnerContainer, { children: [_jsx(ScClassLinkItem, {}, void 0), _jsx(ScCleverItem, {}, void 0), _jsx(ScFerpaItem, {}, void 0), _jsx(ScClassLinkFerpa, {}, void 0)] }, void 0) }), void 0));
};
export { SocialList };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
